<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Categorías de los productos internos" />
    <base-material-card color="indigo" icon="mdi-book-multiple" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-spacer />
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="listadoCategorias"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Categorías de los productos internos</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nueva categoría</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" v-if="editedItem.id">
                        <v-text-field v-model="editedItem.id" disabled label="Id"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="8">
                        <v-text-field v-model="editedItem.nombre" label="Nombre"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="editedItem.hojaExportar"
                          min="1"
                          type="number"
                          step="1"
                          label="Hoja excel de exportación"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="save" :loading="loadingSave">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="blue"
                min-width="0"
                small
                v-on="on"
                @click="editItem(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar Categoria</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="red"
                min-width="0"
                small
                v-on="on"
                @click="deleteItem(item)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar Categoría</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-alert>Sin datos</v-alert>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    loading: false,
    loadingSave: false,
    dialog: false,
    headers: [
      {
        text: "Id",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Nombre", value: "nombre", sortable: false },
      { text: "Hoja exportar", value: "hojaExportar", sortable: false },
      { text: "Acciones", value: "acciones", sortable: false, align: "right" },
    ],
    editedItem: {
      id: null,
      nombre: "",
      hojaExportar: null,
    },
    defaultItem: {
      id: null,
      nombre: "",
      hojaExportar: 1,
    },
  }),

  computed: {
    formTitle() {
      return this.editedItem.id === null
        ? "Nueva categoria"
        : "Editar Categorías";
    },
    ...mapState({
      listadoCategorias: (state) => state.internos.categorias,
    }),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {},

  methods: {
    reload() {
      const _vue = this;
      this.loading = true;
      this.getCategorias().finally(() => {
        _vue.loading = false;
      });
    },
    ...mapActions({
      getCategorias: "internos/getCategorias",
    }),
    editItem(item) {
      this.editedItem = item;
      this.dialog = true;
    },

    deleteItem(item) {
      const _vue = this;
      _vue.loading = true;
      this.$confirm(
        "¿Desea eliminar esta categoría? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      ).then((res) => {
        if (res) {
          return this.$store
            .dispatch("internos/deleteCategoria", item)
            .then((r) => {
              _vue.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Categoria eliminada",
              });
            })
            .catch((e) => {
              _vue.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al eliminar categoria interna: " + e,
              });
            })
            .finally(() => {
              _vue.loading = false;
              this.reload();
              this.close();
            });
        }
      });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },

    save() {
      const _vue = this;
      _vue.loadingSave = true;
      this.$store
        .dispatch("internos/addCategoria", this.editedItem)
        .then((r) => {
          _vue.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Categoria añadida",
          });
        })
        .catch((e) => {
          _vue.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Error al añadir categoria interna: " + e,
          });
        })
        .finally(() => {
          _vue.loadingSave = false;
          this.reload();
          this.close();
        });
    },
  },
};
</script>

<style>
</style>